import React, { Fragment, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AceEditor from 'react-ace';

import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/theme-kuroir';
import 'ace-builds/src-noconflict/theme-monokai';

import MenuVariaveis from '../../MenuVariaveis';

export default (props) => {
  const { answerHandlerOpen, toggleAnswerHandler, doUpdateItem, item } = props;

  const { i18n } = useTranslation();

  const [methodDropdownOpen, setMethodDropdownOpen] = useState(false);
  const [urlEndpoint, setUrlEndpoint] = useState(item.urlEndpoint || '');
  const [jsonPayload, setJsonPayload] = useState(item.jsonPayload || '');
  const [httpHeaders, setHttpHeaders] = useState(item.httpHeaders || '');
  const [waitResponse, setWaitResponse] = useState(item.waitResponse);
  const [timeout, setTimeout] = useState(item.timeout || 10000);

  item.methodType = item.methodType ? item.methodType : 'GET';

  useEffect(() => {
    setMethodDropdownOpen(false);
    setUrlEndpoint(item.urlEndpoint || '');
    setJsonPayload(item.jsonPayload || '');
    setHttpHeaders(item.httpHeaders || '');
    setWaitResponse(item.waitResponse);
    setTimeout(item.timeout || 10000);
  }, [item]);

  const toggleMethodDropdown = () => {
    setMethodDropdownOpen(!methodDropdownOpen);
  };

  const updateMethodType = (type) => {
    toggleMethodDropdown();
    item.methodType = type;
    doUpdateItem({ methodType: type });
  };

  const updateWaitResponse = (value) => {
    setWaitResponse(value);
    doUpdateItem({ waitResponse: value });
  };

  const updateJsonPayload = (value) => {
    setJsonPayload(value);
    doUpdateItem({ jsonPayload: value });
  };

  const onInputChanged = (e, state) => {
    const { name, value } = e.target;
    state(value);
    const payload = {};
    payload[name] = value;
    doUpdateItem(payload);
  };

  const handleSelectVariavel = (name, value, variavel, setState) => {
    const newValue = `${value} ${variavel}`;

    setState(newValue);
    doUpdateItem({ [name]: newValue });
  };

  const onInputBlur = (name, value) => {
    if (item[name] !== value) {
      const { botid } = props.match.params;
      const payload = {
        botid,
        itemid: item._id,
      };
      payload[name] = value;
      doUpdateItem(payload);
    }
  };

  return (
    <Fragment>
      <p className="pointer handler-title" onClick={toggleAnswerHandler}>
        {i18n.t('JSON API')}{' '}
        <img
          alt=""
          className={`seta-expander ${
            !answerHandlerOpen ? 'arrow-rotation' : ''
          }`}
          src="/assets/images/icons/seta_close.svg"
        />
      </p>

      {/* URL ENDPOINT */}
      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel(
            'urlEndpoint',
            urlEndpoint,
            `{${variavel}}`,
            setUrlEndpoint
          )
        }
        buttonRight="27px"
        buttonBottom="25px"
        id={`bloco-${item._id}-configuracao-urlEndpoint`}
        isTooltip
        hidden={!answerHandlerOpen}
      >
        <div className="common-form-group">
          <label>{i18n.t('URL Endpoint')}</label>
          <input
            type="url"
            id="api-urlEndpoint"
            name="urlEndpoint"
            className="form-control mt-1"
            value={urlEndpoint}
            onChange={(e) => onInputChanged(e, setUrlEndpoint)}
          />
        </div>
      </MenuVariaveis>

      {/* JSON PAYLOAD */}
      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel(
            'jsonPayload',
            jsonPayload,
            `$$${variavel}$$`,
            setJsonPayload
          )
        }
        buttonRight="27px"
        buttonBottom="25px"
        id={`bloco-${item._id}-configuracao-jsonPayload`}
        isTooltip
        hidden={!answerHandlerOpen}
      >
        <div className="common-form-group">
          <label>{i18n.t('JSON Payload')}</label>
          <img
            className="right-button"
            src={require('../../../assets/images/expandir.svg')}
            data-toggle="modal"
            data-target="#modal-code-editor"
            alt=""
          />
          <textarea
            className="form-control mt-1"
            value={jsonPayload}
            id="api-jsonpayload"
            name="jsonPayload"
            onChange={(e) => onInputChanged(e, setJsonPayload)}
          />
        </div>
      </MenuVariaveis>

      {/* HTTP METHOD */}
      <div
        className="form-group validation-input-group destination-input-group mb-1"
        hidden={!answerHandlerOpen}
      >
        <label>{i18n.t('Método HTTP')}</label>
        <input
          type="text"
          disabled
          className="form-control outline-none input-control mt-1"
          value={item.methodType || ''}
        />
        <i className="arrow down" />
        <button onClick={toggleMethodDropdown} />
        <div className="validation-dropdown" hidden={!methodDropdownOpen}>
          {/* GET */}
          <div
            className="validation-dropdown-line"
            onClick={() => updateMethodType('GET')}
          >
            <span>GET</span>
            <i className="arrow down" hidden={item.methodType !== 'GET'} />
          </div>
          {/* POST */}
          <div
            className="validation-dropdown-line"
            onClick={() => updateMethodType('POST')}
          >
            <span>POST</span>
            <i className="arrow down" hidden={item.methodType !== 'POST'} />
          </div>
          {/* PUT */}
          <div
            className="validation-dropdown-line"
            onClick={() => updateMethodType('PUT')}
          >
            <span>PUT</span>
            <i className="arrow down" hidden={item.methodType !== 'PUT'} />
          </div>
          {/* DELETE */}
          <div
            className="validation-dropdown-line"
            onClick={() => updateMethodType('DELETE')}
          >
            <span>DELETE</span>
            <i className="arrow down" hidden={item.methodType !== 'DELETE'} />
          </div>
          {/* OPTIONS */}
          <div
            className="validation-dropdown-line"
            onClick={() => updateMethodType('OPTIONS')}
          >
            <span>OPTIONS</span>
            <i className="arrow down" hidden={item.methodType !== 'OPTIONS'} />
          </div>
          {/* PATCH */}
          <div
            className="validation-dropdown-line"
            onClick={() => updateMethodType('PATCH')}
          >
            <span>PATCH</span>
            <i className="arrow down" hidden={item.methodType !== 'PATCH'} />
          </div>
          <div
            className="validation-dropdown-line"
            onClick={() => updateMethodType('PATCH')}
          >
            <span />
            <i className="arrow down" hidden={item.methodType !== ''} />
          </div>
        </div>
      </div>

      {/* HTTPD HEADERS */}
      {/* <div className="common-form-group" hidden={!answerHandlerOpen}>
        <label>{i18n.t("Cabeçalhos HTTP")}</label>
        <textarea
          className="form-control textarea-h-40 mt-1"
          id={'api-httpHeaders'}
          value={httpHeaders}
          onChange={e => {
            onInputChanged(e.target.value, setHttpHeaders);
          }}
          onBlur={e => {
            onInputBlur("httpHeaders", httpHeaders);
          }}
        />
        <img className="variable" src={require("../../../assets/images/variavel.svg")} alt="" />
      </div> */}

      {/* Response Attributes */}
      {/* Aguardar retorno */}
      <div className="form-group row mb-1">
        <div className="custom-control custom-switch mt-2">
          <input
            type="checkbox"
            className="custom-control-input"
            name="waitResponse"
            id="api-waitResponse"
            checked={waitResponse}
            value={waitResponse}
            disabled={props.item && props.item.type === 'Menu'}
            onChange={() => updateWaitResponse(!waitResponse)}
          />
          <label className="custom-control-label" htmlFor="api-waitResponse">
            Aguardar resposta
          </label>
        </div>
      </div>
      <div className="form-group tries-amount mb-0" hidden={!answerHandlerOpen}>
        <span>{i18n.t('timeout')}:&nbsp;</span>
        <input
          type="number"
          id="error-maxtries"
          name="timeout"
          value={timeout || ''}
          onChange={(e) => onInputChanged(e, setTimeout)}
        />
      </div>

      {/* SEE RESPONSE FORMAT */}
      <div className="mt-2" hidden={!answerHandlerOpen}>
        {/* eslint-disable-next-line */}
        <a
          className="link"
          href="javascript:void(0)"
          data-toggle="modal"
          data-target="#modal-response-format"
        >
          {i18n.t('Ver formato de resposta')}
        </a>
      </div>

      {/* MODAL RESPONSE FORMAT */}
      <div
        className="modal fade"
        id="modal-response-format"
        role="dialog"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered ajust-modal-dialog"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {i18n.t('Configuraçoes de retorno')}
              </h5>
              <br />
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="response-title-editor-ace">
                {i18n.t('Use esta resposta para mandar mensagens de texto')}
              </div>
              <div className="response-editor">
                <AceEditor
                  placeholder=""
                  mode="javascript"
                  theme="kuroir"
                  name="response-format"
                  disabled
                  onChange={() => {}}
                  className="response-editor-ace"
                  fontSize={12}
                  showPrintMargin
                  showGutter={false}
                  highlightActiveLine={false}
                  readOnly
                  value={`
                  {
                    "messages": [
                      "aaaaaaaaaaa",
                      "bbbbb bbbbb"
                    ]
                  }`}
                  setOptions={{
                    enableBasicAutocompletion: false,
                    enableLiveAutocompletion: false,
                    enableSnippets: false,
                    showLineNumbers: false,
                    tabSize: 2,
                  }}
                />
              </div>
              <div className="response-title-editor-ace">
                {i18n.t('Use esta resposta para atualizar variaveis do Bot')}
              </div>
              <div className="response-editor">
                <AceEditor
                  placeholder=""
                  mode="javascript"
                  theme="kuroir"
                  name="response-format"
                  disabled
                  onChange={() => {}}
                  className="response-editor-ace"
                  fontSize={12}
                  showPrintMargin
                  showGutter={false}
                  highlightActiveLine={false}
                  readOnly
                  value={`
                  {
                    "updateVariables": [
                      {"nmClient": "aaaaa aaaaaa"},
                      {"nuTelephone": "(xx) xxxx xxxx"}
                    ]
                  }`}
                  setOptions={{
                    enableBasicAutocompletion: false,
                    enableLiveAutocompletion: false,
                    enableSnippets: false,
                    showLineNumbers: false,
                    tabSize: 2,
                  }}
                />
              </div>
              <div className="response-title-editor-ace">
                {i18n.t('Podem ser combinados os dois modelos')}
              </div>
              <div className="response-editor">
                <AceEditor
                  placeholder=""
                  mode="javascript"
                  theme="kuroir"
                  name="response-format"
                  disabled
                  onChange={() => {}}
                  className="response-editor-ace"
                  fontSize={12}
                  showPrintMargin
                  showGutter={false}
                  highlightActiveLine={false}
                  readOnly
                  value={`
                  {
                    "messages": [
                      "aaaaaaaaaaa",
                      "bbbbb bbbbb"
                    ],
                    "updateVariables": [
                      {"nmClient": "aaaaa aaaaaa"},
                      {"nuTelephone": "(xx) xxxx xxxx"}
                    ]
                  }`}
                  setOptions={{
                    enableBasicAutocompletion: false,
                    enableLiveAutocompletion: false,
                    enableSnippets: false,
                    showLineNumbers: false,
                    tabSize: 2,
                  }}
                />
              </div>
            </div>
            {/* <div className="modal-footer"> */}
            {/*  <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button> */}
            {/*  <button type="button" className="btn btn-primary">Save changes</button> */}
            {/* </div> */}
          </div>
        </div>
      </div>

      {/* CODE EDITOR */}
      <div
        className="modal fade"
        id="modal-code-editor"
        role="dialog"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered ajust-centered-mod"
          role="document"
        >
          <div className="modal-content ajust-modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{i18n.t('JSON Payload')}</h5>
              <br />
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <AceEditor
                placeholder=""
                mode="javascript"
                theme="monokai"
                name="jsonPayload"
                id="api-code-editor"
                className="response-editor-ace code-editor mt-2"
                onChange={(value) => updateJsonPayload(value)}
                fontSize={12}
                showPrintMargin
                showGutter
                highlightActiveLine={false}
                value={jsonPayload}
                setOptions={{
                  enableBasicAutocompletion: false,
                  enableLiveAutocompletion: false,
                  enableSnippets: false,
                  showLineNumbers: true,
                  tabSize: 2,
                }}
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
              >
                {i18n.t('salvar')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
